import { FC, PropsWithChildren, ReactNode } from 'react';

import { Connect } from '@components';
import { composeClassName } from '@utilities';

import styles from './index.module.scss';

type Props = PropsWithChildren<{
	text: ReactNode;
	title: string;
	image?: string;
}>;

export const Hero: FC<Readonly<Props>> = ({ text, title, image, children }) => (
	<div
		style={image ? { backgroundImage: `url(${image})` } : {}}
		className={composeClassName(styles.hero, !children ? '' : styles.adjusted)}
		data-testid="hero-image"
	>
		<div className={styles.content}>
			<div className={`shell ${styles.shell}`}>
				<h1>{title}</h1>
				{text}
				<Connect />

				{children}
			</div>
		</div>
	</div>
);

export default Hero;
